<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <div class="permissao vertical-flow">
                    <div class="listing-header">
                        <!-- TÍTULO E BREADCRUMB -->
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('acessos-permissoes') }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('colaborador') }}</a>
                                    </li>
                                    <li>
                                        <a href="#" aria-current="page">{{
                                            $t('acessos-permissoes')
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <!-- BOTÕES -->
                        <div class="header-buttons">
                            <router-link
                                v-if="perm_perfilacessotelas.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                :to="{ name: 'usuario-acessos-permissoes-new' }"
                            >
                                {{ $t('adicionar') }}
                            </router-link>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="onSituacaoChanged"
                                v-model="situacao"
                            >
                                <template slot="no-options">{{
                                    $t('sem-resultados')
                                }}</template>
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <!-- LISTAGEM -->
                    <div class="permissao-table registry-wrapper">
                        <empty-table-message v-if="allprofiles && !allprofiles.length" />
                        <b-table
                            v-else
                            :data="allprofiles"
                            :mobile-cards="false"
                            class="data-table"
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'perfil'">
                                    <span v-if="!$store.state.user.admin && props.row.admin">{{
                                        props.row.nome
                                    }}</span>
                                    <router-link
                                        :to="{
                                            name: 'usuario-acessos-permissoes-edit',
                                            params: { id: props.row.id },
                                        }"
                                        v-else
                                    >
                                        {{ props.row.nome }}
                                    </router-link>
                                </div>

                                <div class="situacao-acessos" v-else-if="f.key == 'situacao'">
                                    <div class="situacao-descricao">
                                        <b-tag
                                            class="table-tag"
                                            v-if="props.row[f.key] == 1"
                                            type="is-success"
                                            size="is-medium"
                                            >{{ $t('ativo') }}</b-tag
                                        >
                                        <b-tag
                                            class="table-tag"
                                            v-else
                                            type="is-warning"
                                            size="is-medium"
                                            >{{ $t('bloqueado') }}</b-tag
                                        >
                                    </div>
                                    <div
                                        class="change-situacao"
                                        v-if="
                                            perm_perfilacessotelas.delete &&
                                            props.row.datahoradel == null &&
                                            !props.row.admin
                                        "
                                    >
                                        <b-button
                                            type="is-danger"
                                            icon-right="delete"
                                            @click="confirmExclusion(props.row)"
                                        />
                                    </div>
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes('usuario-acessos-permissoes') &&
            to.name != 'usuario-acessos-permissoes'
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    data() {
        return {
            allprofiles: [],
            fields: [
                { key: 'perfil', sortable: false },
                { key: 'situacao', sortable: false, width: 150 },
            ],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            deleteThis: {},
            debouncedOnSearch: null,
            column: 'datahora',
            order: 'desc',
            perm_perfilacessotelas: {},
            queryFilter: null,
        };
    },
    created() {
        if (
            this.$route.name.includes('usuario-acessos-permissoes') &&
            this.$route.name != 'usuario-acessos-permissoes'
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        // router.push({ name: 'user', params: { userId: '123' } })
        this.perm_perfilacessotelas = this.hasPermissionAccess(
            'admin',
            'colaborador',
            'usuario-acessos-permissoes'
        );
        if (!this.perm_perfilacessotelas.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'acessos-permissoes' },
            });
        } else {
            this.carregarDados();
        }
    },

    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = value.trim();
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.$store.commit('addLoader');
            let urlRequest =
                'config/access-profile.json' +
                `?page=${currentPage - 1}` +
                `&limit=${this.pagination.perPage}` +
                `&order=${this.order}` +
                `&column=${this.column}` +
                `&situacao=${this.situacao.id}`;
            if (!this.isNull(this.queryFilter)) {
                urlRequest += `&param=${this.queryFilter}`;
            }
            this.$axios
                .get(urlRequest)
                .then((response) => {
                    this.allprofiles = response.data.content;
                    this.pagination.totalRows = response.data.totalElements;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.$store.commit('removeLoader');
                });
        },
        sortTable(field, order) {
            console.log(`Ordenando listagem por [${field}|${order}]`);
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            let temp = null;
            if (val) {
                temp = this.situacoes.filter((v) => v.id == val.id);
                this.situacao = temp[0];
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        confirmExclusion(item) {
            this.deleteThis = item;
            this.active = 2;

            this.$root.confirm({
                message: this.$t('msg-confirm-delecao-perfil-acesso'),
                onConfirm: this.deletePerfil,
                onCancel: (_) => {
                    this.deleteThis = null;
                },
            });
        },
        deletePerfil() {
            this.$store.commit('addLoader');
            this.$axios
                .delete(`config/access-profile/${this.deleteThis.id}`)
                .then((r) => {
                    this.$root.showMessage('success', 'msg-perfil-acesso-deletado');
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error('Erro ao remover perfil acesso.', e);
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.$store.commit('removeLoader');
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.table-tag,
.situacao-descricao {
    width: 100% !important;
}

#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }

    .permissao {
        .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 80%;
                padding-right: 10px;
            }
            .situacao-select {
                width: 30%;
                div {
                    height: 40px;
                }
            }
        }

        .situacao-acessos {
            display: flex;

            .situacao-descricao {
                margin-right: 10px;
            }
        }
    }
}
</style>
